import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { formatLaunchTime } from '../../../../_shared/helpers/formatting';
import ActiveBids from './ActiveBids';
import { TradeState, TradeViewVariant } from '../../../../_shared/types/trade';
import {
  StyledTitle,
  StyledMakeModelYear,
  StyledBadge,
  StyledMake,
  StyledModel,
  StyledTradeHeading,
  StyledLaunchingToActive
} from './Styles';

const propTypes = {
  tradeSummary: PropTypes.shape({
    year: PropTypes.number.isRequired,
    make: PropTypes.string.isRequired,
    model: PropTypes.string.isRequired
  }).isRequired
};

const Title = ({ tradeSummary, variant, isStateChangedToActive }) => {
  const tradeState = useSelector(
    state => state?.ui?.nav?.secondary?.context,
    shallowEqual
  );
  const { year, make, model, statusDates } = tradeSummary;
  const { id: launchId, values: launchValues } = formatLaunchTime(
    tradeState,
    statusDates,
    TradeViewVariant.LIST
  );

  return (
    <StyledTitle variant={variant}>
      <StyledMakeModelYear variant={variant}>
        <StyledBadge
          data-testid={`list-year-${tradeSummary?.id}`}
          variant={variant}
        >
          {year}
        </StyledBadge>
        <StyledMake
          data-testid={`list-make-${tradeSummary?.id}`}
          variant={variant}
          className="notranslate"
        >
          {make}
        </StyledMake>
        <StyledModel
          data-testid={`list-model-${tradeSummary?.id}`}
          variant={variant}
          className="notranslate"
        >
          {model}
        </StyledModel>
      </StyledMakeModelYear>
      <StyledTradeHeading>
        {tradeState === TradeState.active && (
          <ActiveBids tradeSummary={tradeSummary} />
        )}
        {tradeState === TradeState.upcoming && launchId && launchValues && (
          <StyledLaunchingToActive
            data-testid={`upcoming-list-launching-to-active-${tradeSummary?.id}`}
          >
            {!isStateChangedToActive ? (
              <FormattedMessage id={launchId} values={launchValues} />
            ) : (
              <FormattedMessage
                id="list.launchTime.active.today"
                values={launchValues}
              />
            )}
          </StyledLaunchingToActive>
        )}
      </StyledTradeHeading>
    </StyledTitle>
  );
};

Title.propTypes = propTypes;

export default Title;
